// Methods not using "this" are implementing the interface and cannot be static
/* eslint-disable class-methods-use-this */

import { AxiosResponse } from 'axios';
import VersionedResource from '../VersionedResource';
import { WrittenOffSettings } from './loanaccounts/WrittenOffSettings';
import { StatusSettingsResource } from '../accountstatussettings/StatusSettingsResource';
import { StatusSettings } from '../accountstatussettings/StatusSettings';
import { WrittenOffStatusIndicator } from './statusindicators/WrittenOffStatusIndicator';

export class WrittenOffSettingsResource extends VersionedResource implements StatusSettingsResource {
  public async save(fiId: string, settings: WrittenOffSettings): Promise<WrittenOffSettings> {
    const url = `/api/rcx/config/${fiId}/loan-account-settings/written-off`;

    const response: AxiosResponse = await this.apiClient.put(url, settings);
    return response.data.data;
  }

  createEmptySettings(): WrittenOffSettings {
    return {
      statusIndicator: WrittenOffStatusIndicator.UNSET,
      statusCodes: [],
      active: true,
    };
  }

  setIndicatorsOnSettings(settings: StatusSettings, values: string[], conditionalOr: boolean | null) {
    const writtenOffSettings = settings as WrittenOffSettings;

    const conditional: string = conditionalOr ? '_OR_' : '_AND_';

    let statusIndicator: string = '';

    if (values.includes(WrittenOffStatusIndicator.STATUS_CODE)) {
      statusIndicator = WrittenOffStatusIndicator.STATUS_CODE;
    }

    if (values.includes(WrittenOffStatusIndicator.PRODUCT_CODE)) {
      if (statusIndicator.length > 0) {
        statusIndicator += conditional;
      }
      statusIndicator += WrittenOffStatusIndicator.PRODUCT_CODE;
    }

    if (values.includes(WrittenOffStatusIndicator.WRITTEN_OFF_DATE)) {
      if (statusIndicator.length > 0) {
        statusIndicator += conditional;
      }
      statusIndicator += WrittenOffStatusIndicator.WRITTEN_OFF_DATE;
    }

    writtenOffSettings.statusIndicator = statusIndicator as WrittenOffStatusIndicator;
  }

  getIndicatorsFromSettings(settings: StatusSettings): string[] | null {
    const writtenOffSettings = settings as WrittenOffSettings;
    let indicators: string[] = [];
    switch (writtenOffSettings.statusIndicator) {
      case WrittenOffStatusIndicator.UNSET:
        indicators = [];
        break;

      case WrittenOffStatusIndicator.WRITTEN_OFF_DATE:
        indicators = [WrittenOffStatusIndicator.WRITTEN_OFF_DATE];
        break;

      case WrittenOffStatusIndicator.STATUS_CODE:
        indicators = [WrittenOffStatusIndicator.STATUS_CODE];
        break;

      case WrittenOffStatusIndicator.PRODUCT_CODE:
        indicators = [WrittenOffStatusIndicator.PRODUCT_CODE];
        break;

      case WrittenOffStatusIndicator.PRODUCT_CODE_AND_WRITTEN_OFF_DATE:
      case WrittenOffStatusIndicator.PRODUCT_CODE_OR_WRITTEN_OFF_DATE:
        indicators = [WrittenOffStatusIndicator.PRODUCT_CODE, WrittenOffStatusIndicator.WRITTEN_OFF_DATE];
        break;

      case WrittenOffStatusIndicator.STATUS_CODE_AND_WRITTEN_OFF_DATE:
      case WrittenOffStatusIndicator.STATUS_CODE_OR_WRITTEN_OFF_DATE:
        indicators = [WrittenOffStatusIndicator.STATUS_CODE, WrittenOffStatusIndicator.WRITTEN_OFF_DATE];
        break;

      case WrittenOffStatusIndicator.STATUS_CODE_AND_PRODUCT_CODE:
      case WrittenOffStatusIndicator.STATUS_CODE_OR_PRODUCT_CODE:
        indicators = [WrittenOffStatusIndicator.STATUS_CODE, WrittenOffStatusIndicator.PRODUCT_CODE];
        break;

      default:
        indicators = [WrittenOffStatusIndicator.STATUS_CODE, WrittenOffStatusIndicator.PRODUCT_CODE, WrittenOffStatusIndicator.WRITTEN_OFF_DATE];
        break;
    }

    return indicators;
  }

  getConditionalFromSettings(settings: StatusSettings): string | null {
    const writtenOffSettings = settings as WrittenOffSettings;

    let conditional: string | null = null;

    if (writtenOffSettings.statusIndicator.includes('_OR_')) {
      conditional = 'OR';
    } else if (writtenOffSettings.statusIndicator.includes('_AND_')) {
      conditional = 'AND';
    }

    return conditional;
  }
}

export default WrittenOffSettingsResource;
